export const APP_NAME = 'Scale Mediation'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'

export const AI_INTERNET_ACCESS_MODE = {
  CASE_DOCUMENT_ONLY: 'case_document_only',
  OPEN_INTERNET_ACCESS: 'open_internet_access',
}

export const MEDIATION_DURATION = {
  MORNING: 4,
  AFTERNOON: 4,
  FULLDAY: 8,
}
